module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "panel kb-feedback-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.simpleFeedbackSubmitted) ? _c('div', {
    staticClass: "simple-feedback"
  }, [_c('h2', [_vm._v("Was this page helpful?")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitSimpleFeedback($event)
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.experience = 'positive'
      }
    }
  }, [_vm._v("\n                        Yes, it's perfect!\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.experience = 'negative'
      }
    }
  }, [_vm._v("\n                        No, it could be better.\n                    ")])])])]) : (!_vm.fullFeedbackSubmitted) ? _c('div', {
    staticClass: "full-feedback"
  }, [_c('h2', [_vm._v("Thanks for the feedback!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFullFeedback($event)
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Additional feedback")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "fullFeedback",
    staticClass: "form-control",
    attrs: {
      "placeholder": "Care to elaborate on what you did or didn't like about this page?",
      "cols": "50",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": !_vm.text
    }
  }, [_vm._v("\n                            Submit\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.closeFullFeedback
    }
  }, [_vm._v("\n                            Close\n                        ")])])])])]) : _c('div', {
    staticClass: "done-feedback"
  }, [_c('h2', [_vm._v("Thank you! Your feedback has been saved.")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74e87206!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/KbFeedback.vue
// module id = 2052
// module chunks = 2